module.exports = __webpack_public_path__ + "static/media/whatsapp.774352de.png";